import { jsx as e, jsxs as x } from "react/jsx-runtime";
import { Tooltip as c } from "@systemeio/ui";
import { useEditorState as h } from "../../node_modules/@tiptap/react/dist/index.mjs";
import { useMemo as f } from "react";
import { twMerge as m } from "tailwind-merge";
import { ToolbarButton as b } from "../../components/content-controls/toolbar-button.mjs";
import { TOOLTIP_STYLES as g, getToolbarIconClassName as u } from "../../constants/default-styles.mjs";
import { getShortcut as p, rawShortcuts as I } from "../../utils/get-shortcuts.mjs";
import { setTextFormat as E, getTextFormatIcon as N } from "./utils/text-format.mjs";
import { useTranslation as v } from "../../i18n.mjs";
import { isImageSelected as A } from "../image-extension/utils/is-image-selected.mjs";
const T = (i, s, d) => {
  const { t: n } = v(), l = h({
    editor: i,
    selector: ({ editor: o }) => ({
      isEditable: (o == null ? void 0 : o.options.editable) ?? !1,
      isActive: (o == null ? void 0 : o.isActive(s)) ?? !1,
      isImageSelected: A(o)
    })
  }), t = !(l != null && l.isEditable) || !!(l != null && l.isImageSelected), r = l == null ? void 0 : l.isActive;
  return f(() => {
    const o = () => E({ formatType: s, editor: i }), a = N({ formatType: s });
    return {
      toolbarRender: /* @__PURE__ */ e(
        c,
        {
          disabled: t,
          label: `${n(`${s}`)} (${p(I[s].toggle)})`,
          ...g,
          children: /* @__PURE__ */ e(
            b,
            {
              disabled: t,
              onClick: o,
              className: m(r && "bg-brand-primary/10 main-transition-colors"),
              children: /* @__PURE__ */ e(a, { className: u(t) })
            }
          )
        },
        s
      ),
      tooltipRender: /* @__PURE__ */ e(
        c,
        {
          disabled: t,
          label: p(I[s].toggle),
          ...g,
          children: /* @__PURE__ */ x(
            b,
            {
              disabled: t,
              onClick: o,
              className: m(
                r && "bg-brand-primary/10 main-transition-colors",
                "flex gap-1"
              ),
              children: [
                /* @__PURE__ */ e(a, { className: u(t) }),
                n(`${s}`)
              ]
            }
          )
        },
        s
      )
    };
  }, [i, s, r, t, d, n]);
};
export {
  T as useTextFormatExtensionToolbar
};
